/* eslint-disable react/no-multi-comp */
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { MfeLoad } from '@carvana/microfrontend';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { CoreEvents, events } from 'coreEventsOLD';
import Portal from '@Shared/Portal';
import { setSupportMenuState } from '../../SupportDropdown/ducks/actions';
import {
  getContentServiceRequestId,
  getSupportMenuState
} from '../../SupportDropdown/ducks/selectors';
import {
  MenuTitle,
  MenuWrapper,
  PortalContentInnerWrapper,
  PortalContentWrapper,
  StyledArrowDropDown,
  StyledButton
} from './SupportDesktop.styles';
import { getDoesBannerExist, getIsInDotCom } from '../../ducks/selectors';
import { IsServerSideRendering } from '@utilities';

class SupportDesktop extends PureComponent {
  static contextType = AnalyticsContext;

  constructor(props) {
    super(props);

    this.state = {
      hasSentEventable: false,
      topicId: '',
      articleId: ''
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this._handleKeyDown);
    CoreEvents.on(events.supportDropDown.open, this._openSdd);
    CoreEvents.on(events.supportDropDown.close, this._closeSdd);
  }

  _openSdd = e => {
    this.setState({
      topicId: e?.detail?.topicId,
      articleId: e?.detail?.articleId
    });
    this.toggleDropdown(true);
  };

  _closeSdd = () => {
    this.setState({ topicId: '', articleId: '' });
    this.toggleDropdown(false);
  };

  componentWillUnmount() {
    CoreEvents.off(events.supportDropDown.open, this._openSdd);
    CoreEvents.off(events.supportDropDown.close, this._closeSdd);
  }

  _handleKeyDown = event => {
    if (event.keyCode === 27) this.toggleDropdown(false);
  };

  toggleDropdown = isDropdownExpanded => {
    const { hasSentEventable } = this.state;
    const { updateSupportMenuState } = this.props;
    if (isDropdownExpanded && !hasSentEventable) {
      const { trackEvent } = this.context;
      trackEvent('user platform - header - expanded support & contact menu', { platform: 'desktop' });

      this.setState({ hasSentEventable: true });
    }

    updateSupportMenuState(isDropdownExpanded);
  };

  shouldShowP2PSSD = () => {
    try {
      const shouldShowP2P =
        !IsServerSideRendering &&
        window.location.href.includes('vehicles/community/');
      return shouldShowP2P;
    } catch (e) {
      console.log(e);
      return true;
    }
  };

  render() {
    const { isSupportMenuOpen, isInDotCom } = this.props;

    return (
      <Fragment>
        <MenuWrapper
          data-cv-test="headerSupportDropdown"
          isDropdownExpanded={isSupportMenuOpen}
        >
          <StyledButton
            onClick={() => {
              if (isSupportMenuOpen) {
                this._closeSdd();
              } else {
                this._openSdd();
              }
            }}
            disableHref
          >
            <MenuTitle isDropdownExpanded={isSupportMenuOpen}>
              Support & Contact
            </MenuTitle>
            <StyledArrowDropDown isDropdownExpanded={isSupportMenuOpen} />
          </StyledButton>
          <Portal>
            <PortalContentWrapper isDropdownExpanded={isSupportMenuOpen}>
              <PortalContentInnerWrapper
                className={classnames({ 'has-max-width': !isInDotCom })}
              >
                {/* HACK: EXTERNAL STYLES FOR THIS EXIST!!! check the function `setSupportDropDownPositioningStyles` in CarvanaHeader.js */}
                {isSupportMenuOpen && (
                  <MfeReactComponent
                    module="CoreSupportDropdown"
                    component="default"
                    isOpen={isSupportMenuOpen}
                    closeModal={() => this._closeSdd()}
                    openToTopic={this.state.topicId}
                    openToArticle={this.state.articleId}
                  />
                )}
              </PortalContentInnerWrapper>
            </PortalContentWrapper>
          </Portal>
        </MenuWrapper>
      </Fragment>
    );
  }
}

SupportDesktop.propTypes = {
  updateSupportMenuState: PropTypes.func.isRequired,
  contentServiceRequestId: PropTypes.string.isRequired,
  isSupportMenuOpen: PropTypes.bool.isRequired,
  isInDotCom: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  contentServiceRequestId: getContentServiceRequestId(state),
  isInDotCom: getIsInDotCom(state),
  doesBannerExist: getDoesBannerExist(state),
  isSupportMenuOpen: getSupportMenuState(state)
});

const mapDispatchToProps = dispatch => ({
  updateSupportMenuState: isOpen => {
    if (isOpen) {
      MfeLoad({
        files: [
          [
            'CoreSupportDropdown',
            [
              {
                component: 'default',
                default: {
                  file: 'index.js',
                  manifest: process.env.CVNA_APP_SDD_URL
                }
              }
            ]
          ]
        ]
      });
    }

    dispatch(setSupportMenuState(isOpen));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SupportDesktop);
